var map = {
	"./img_additional_pos.svg": 65177,
	"./img_adentro.svg": 31803,
	"./img_aloha.svg": 83793,
	"./img_ansa.svg": 27443,
	"./img_attentive.svg": 43878,
	"./img_bikky.svg": 81462,
	"./img_braze.svg": 35207,
	"./img_delightable.png": 68381,
	"./img_deliverect.svg": 43915,
	"./img_doordash.svg": 38842,
	"./img_fishbowl.svg": 22573,
	"./img_flybuy.svg": 135,
	"./img_guestxm.svg": 86769,
	"./img_jotform.svg": 63662,
	"./img_klaviyo.svg": 25420,
	"./img_momos.svg": 29426,
	"./img_ncr.svg": 83156,
	"./img_olo.svg": 46288,
	"./img_olo_dispatch.svg": 75714,
	"./img_olo_gdp.svg": 92905,
	"./img_olo_omnivore.svg": 36266,
	"./img_omnivore.svg": 84769,
	"./img_open_tender.svg": 64328,
	"./img_oracle_micros.svg": 67060,
	"./img_ovation.svg": 95382,
	"./img_par_brink.svg": 1632,
	"./img_pos_itouch.svg": 97304,
	"./img_revel.svg": 96212,
	"./img_tattle.svg": 30357,
	"./img_thanx.svg": 76522,
	"./img_toast.svg": 1798,
	"./img_uber.svg": 33473,
	"./img_union.svg": 39154,
	"./img_vromo.svg": 74519,
	"./img_yumpingo.svg": 80508,
	"assets/images/integrations/logos/img_additional_pos.svg": 65177,
	"assets/images/integrations/logos/img_adentro.svg": 31803,
	"assets/images/integrations/logos/img_aloha.svg": 83793,
	"assets/images/integrations/logos/img_ansa.svg": 27443,
	"assets/images/integrations/logos/img_attentive.svg": 43878,
	"assets/images/integrations/logos/img_bikky.svg": 81462,
	"assets/images/integrations/logos/img_braze.svg": 35207,
	"assets/images/integrations/logos/img_delightable.png": 68381,
	"assets/images/integrations/logos/img_deliverect.svg": 43915,
	"assets/images/integrations/logos/img_doordash.svg": 38842,
	"assets/images/integrations/logos/img_fishbowl.svg": 22573,
	"assets/images/integrations/logos/img_flybuy.svg": 135,
	"assets/images/integrations/logos/img_guestxm.svg": 86769,
	"assets/images/integrations/logos/img_jotform.svg": 63662,
	"assets/images/integrations/logos/img_klaviyo.svg": 25420,
	"assets/images/integrations/logos/img_momos.svg": 29426,
	"assets/images/integrations/logos/img_ncr.svg": 83156,
	"assets/images/integrations/logos/img_olo.svg": 46288,
	"assets/images/integrations/logos/img_olo_dispatch.svg": 75714,
	"assets/images/integrations/logos/img_olo_gdp.svg": 92905,
	"assets/images/integrations/logos/img_olo_omnivore.svg": 36266,
	"assets/images/integrations/logos/img_omnivore.svg": 84769,
	"assets/images/integrations/logos/img_open_tender.svg": 64328,
	"assets/images/integrations/logos/img_oracle_micros.svg": 67060,
	"assets/images/integrations/logos/img_ovation.svg": 95382,
	"assets/images/integrations/logos/img_par_brink.svg": 1632,
	"assets/images/integrations/logos/img_pos_itouch.svg": 97304,
	"assets/images/integrations/logos/img_revel.svg": 96212,
	"assets/images/integrations/logos/img_tattle.svg": 30357,
	"assets/images/integrations/logos/img_thanx.svg": 76522,
	"assets/images/integrations/logos/img_toast.svg": 1798,
	"assets/images/integrations/logos/img_uber.svg": 33473,
	"assets/images/integrations/logos/img_union.svg": 39154,
	"assets/images/integrations/logos/img_vromo.svg": 74519,
	"assets/images/integrations/logos/img_yumpingo.svg": 80508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34197;